export default "__VITE_ASSET__a55b568d__"